import { isValid } from 'date-fns';

/**
 *
 * @param date
 * @returns
 */
export function getDateParts(date: Date): DateParts {
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  return { year, month, day };
}

interface DateParts {
  year: string;
  month: string;
  day: string;
}

export const parseDate = (isoDate?: string | number): Date | undefined => {
  if (!isoDate) {
    return undefined;
  }

  const parsed = new Date(isoDate);

  if (!isValid(parsed)) {
    return undefined;
  }

  return parsed;
};
